import React, { JSXElementConstructor, ReactElement, ReactNode } from 'react';

type SearchableElement = JSXElementConstructor<any> & { searchable: true };
export function isSearchable(
  node: string | JSXElementConstructor<any> | SearchableElement,
): node is (x: any) => ReactElement {
  return typeof node === 'function' && 'searchable' in node && node.searchable;
}

function isNodeMatch(node: ReactNode, filter: string): boolean {
  if (typeof node === 'number' || typeof node === 'boolean' || typeof node === 'undefined' || node === null) {
    return false;
  }
  if (typeof node === 'string') {
    return node.toLowerCase().includes(filter.toLowerCase());
  }
  if (Array.isArray(node)) {
    return Array.from(node).some((child) => isNodeMatch(child, filter));
  }
  if ('children' in node) {
    return isNodeMatch(node.children, filter);
  }
  if (React.isValidElement<any>(node)) {
    if (node.type === 'svg') {
      return false;
    }
    const ctor = node.type;
    if (isSearchable(ctor)) {
      return isNodeMatch(ctor(node.props), filter);
    }
    return isNodeMatch(node.props.children, filter);
  }
  return isNodeMatch(Array.from(node), filter);
}

export default isNodeMatch;
